/**
 * OTPless callback initializer
 *
 * This file contains the callback function for OTPless authentication and
 * initializes the OTPless SDK when the window loads.
 */
import { store } from "redux/redux";
import { updateOtplessAutoReadOTP } from "../LoginDataLayer/LoginRedux";

/**
 * Callback function for OTPless authentication events
 */
export const otplessCallback = (eventCallback) => {
  try {
    // Handle successful one-tap authentication
    const ONETAP = () => {
      const { response } = eventCallback;
      window.dispatchEvent(
        new CustomEvent("otplessOneTap", {
          detail: { response },
        })
      );
    };

    // Handle auto-read OTP
    const OTP_AUTO_READ = () => {
      const {
        response: { otp },
      } = eventCallback;

      // Store auto-read OTP in Redux
      store.dispatch(updateOtplessAutoReadOTP(otp));
    };

    // Handle failed authentication
    const FAILED = () => {
      const { response } = eventCallback;
      window.dispatchEvent(
        new CustomEvent("otplessFailed", {
          detail: { response },
        })
      );
    };

    // Handle fallback triggered
    const FALLBACK_TRIGGERED = () => {
      const { response } = eventCallback;
      window.dispatchEvent(
        new CustomEvent("otplessFallback", {
          detail: { response },
        })
      );
    };

    // Map of event handlers
    const EVENTS_MAP = {
      ONETAP,
      OTP_AUTO_READ,
      FAILED,
      FALLBACK_TRIGGERED,
    };

    // Execute appropriate handler
    if ("responseType" in eventCallback)
      EVENTS_MAP[eventCallback.responseType]();
  } catch (error) {
    /* do nothing */
  }
};

/**
 * Initialize the OTPless SDK
 * This should be called when the window loads
 */
export const initializeOTPless = () => {
  if (window.OTPless) {
    try {
      window.OTPlessSignin = new window.OTPless(otplessCallback);
    } catch (error) {
      //
    }
  }
};

// Automatically initialize when imported
if (typeof window !== "undefined") {
  window.addEventListener("load", initializeOTPless);
}
